import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";
import { getVAAccessToken } from "../utils/parseId";
import type {
  EnrichPatientResult,
  EnrichPatientVariables,
} from "../components/dashboard/Record/types";

const notifyEnrichmentFailure = async (vars: EnrichPatientVariables, error: unknown) => {
  try {
    await api.post("/auth/slack-notification", {
      event: "PATIENT_CONTEXT_UPDATE_FAILED",
      patientData: {
        patientId: vars.patientId,
        mrn: vars.mrn,
        error: error instanceof Error ? error.message : String(error),
      },
      userData: { userName: vars.doctorName },
    });
  } catch (err) {
    console.error("Failed to send Slack notification:", err);
  }
};

export function useEnrichPatientMutation() {
  return useMutation({
    mutationFn: async (vars: EnrichPatientVariables): Promise<EnrichPatientResult> => {
      try {
        const accessToken = await getVAAccessToken();
        if (!accessToken) {
          console.warn("⚠️ No VA access token, skipping enrichment");
          return { skipped: true };
        }

        const fhirUrl = localStorage.getItem("va_fhir_server");
        return await api.post<EnrichPatientResult>(`/va/patient/enrich-data/${vars.patientId}`, {
          fhirUrl,
          accessToken,
        });
      } catch (error) {
        await notifyEnrichmentFailure(vars, error);
        throw error;
      }
    },
  });
}

export default useEnrichPatientMutation;
